<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-google-drive']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
